import { render, staticRenderFns } from "./PortalsTable.vue?vue&type=template&id=135bebfe&scoped=true&"
import script from "./PortalsTable.vue?vue&type=script&lang=js&"
export * from "./PortalsTable.vue?vue&type=script&lang=js&"
import style0 from "./PortalsTable.vue?vue&type=style&index=0&id=135bebfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135bebfe",
  null
  
)

export default component.exports